const api = {
  url: "https://app.healthprofile.digital:8080/",
};

export default api;
